import env from 'environment';

const testMenu = ({ t, userInfo }) => [
  {
    title: true,
    name: 'Charts',
  },
  {
    name: 'Bar',
    url: '/test/charts/bar'
  },
  {
    name: 'Web',
    url: '/test/charts/web'
  },
];

const adminMenu = ({ t, userInfo }) => [
  {
    title: true,
    name: 'Sistema',
  },
  {
    name: 'Info',
    url: '/protected/system/info',
    icon: 'fa fa-fw fa-gear'
  },
  {
    name: 'Sessioni',
    url: '/protected/system/sessions',
    icon: 'fa fa-fw fa-users'
  },
];

const workgroupMenu = ({ t, userInfo }) => [
  {
    title: true,
    name: 'Gruppo di lavoro',
  },
  {
    name: 'Gruppi di lavoro',
    url: '/protected/workgroups',
    icon: 'fa fa-fw fa-users'
  },
  {
    name: 'Ruoli',
    url: '/protected/roles',
    icon: 'fa fa-fw fa-list'
  },
  {
    name: 'Utenti',
    url: '/protected/users',
    icon: 'fa fa-fw fa-user'
  },
  {
    name: 'Tag',
    url: '/protected/tags',
    icon: 'fa fa-fw fa-tags'
  },
];

const userMenu = ({ t, userInfo }) => [
  {
    title: true,
    name: 'Funzionalità',
  },
  {
    name: 'Analisi',
    url: '/protected/analyses',
    icon: 'fa fa-fw fa-area-chart'
  },
  {
    name: 'Analisi bilancio',
    url: '/protected/analyses/all/xbrl',
    icon: 'ml-4 fa fa-fw fa-bars'
  },
  {
    name: 'Analisi CR',
    url: '/protected/analyses/all/cr',
    icon: 'ml-4 fa fa-fw fa-podcast'
  },
  {
    name: 'Analisi Crif',
    url: '/protected/analyses/all/crif',
    icon: 'ml-4 fa fa-fw fa-bell'
  },
];

export default ({ t, userInfo }) => [
  ...(userInfo.administrator ? adminMenu({ t, userInfo }) : []),
  ...(userInfo.administrator || userInfo.workgroupAdministrator ? workgroupMenu({ t, userInfo }) : []),
  ...userMenu({ t, userInfo }),
  ...(env.testPages ? testMenu({ t, userInfo }) : []),
];
